var $ = require("jquery");

(function () {
    var $accordion = $("[data-accordion]");

    $accordion.each(function () {        
        const $trigger = $(this).find("[data-accordion-toggle]");        
        $trigger.on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            $this.parent().toggleClass("-expanded");
            $this.attr("aria-expanded", (_, attr) => attr == "true" ? "false" : "true");
        });
    });

})();